<template>
    <layout-machine-introduction :unsaved-puri-count="unsavedPuriCount"
                                 :latest-image-id="latestImageId"
                                 :is-searchable="isSearchable"
                                 :machine-id="machineId"
                                 :section-title-list="sectionTitleList"
                                 :has-top-border-anchor-link="false"
                                 :has-title-anchor-link="false"
                                 :has-border-anchor-link="false"
                                 :has-movie-title="false"
                                 youtube-url="https://www.youtube.com/shorts/j1Z-fYi-L5o"
    >

        <template v-slot:feature-summary>
            <img :src="buildImgUrl('img_feature_summary.png')" alt="piemoの基本情報">
        </template>
        <template v-slot:content-1>
            <div class="cont-01">
                <img class="img-01" :src="buildImgUrl('img_contents01_01.png')" alt="ラメ感できらめく瞳 純白のうるツヤ肌 純欲盛れ">
                <img class="img-02" :src="buildImgUrl('img_contents01_02.png')" alt="盛れ感はこんな感じ♥ さらに！純欲盛れをもっとひきたてるメイク＆レタッチも豊富に搭載！">
            </div>
        </template>
        <template v-slot:content-2>
            <div class="cont-02">
                <div class="cont-02-bk">
                    <img class="img-01" :src="buildImgUrl('img_contents02_01.png')" alt="全身撮影が生まれ変わって新登場！盛れた私で、コーデまで可愛く残せちゃう♥ Face 繊細に可愛く盛れる Body 自然にスタイルアップ">
                    <div class="img-02-wrapper">
                        <img class="img-02" :src="buildImgUrl('img_contents02_02.png')" alt="こんなの待ってた♥新機能スタイルまで思い通りに調整できる！ボディレタッチ さらに...!フリュー史上初！服の色がより映えて、コーデをもっと可愛く残せる♥コーデカラー補正">
                        <img class="gif-01" :src="buildImgUrl('gif_1.gif')" alt="脚長レタッチ">
                        <img class="gif-02" :src="buildImgUrl('gif_2.gif')" alt="広角レタッチ">
                    </div>
                </div>
            </div>
        </template>
        <template v-slot:content-3>
            <div class="cont-03">
                <div class="cont-03-bk">
                    <img class="img-01" :src="buildImgUrl('img_contents03_01.png')" alt="piemoだけのトレンド 可愛い背景がいーっぱい！ カラー・デザインのバリエーションは全100種類以上！">
                    <img class="img-02" :src="buildImgUrl('img_contents03_02.png')" alt="piemoだけのトレンド 可愛い背景">
                </div>
            </div>
        </template>
        <template v-slot:content-4>
            <div class="cont-04">
                <div class="cont-04-bk">
                    <img class="img-01" :src="buildImgUrl('img_contents04_01.png')" alt="誰でも簡単！選ぶだけで超可愛い仕上がりになる♥一発落書き 豊富な種類でアップにも全身にも使えるよ">
                    <img class="img-02" :src="buildImgUrl('img_contents04_02.png')" alt="落書きをもっとこだわりたい子も大満足豊富なペン 平成プリの定番だった懐かしペンも！">
                    <img class="img-03" :src="buildImgUrl('img_contents04_03.png')" alt="トレンド可愛いコンテンツがいーっぱい♥豊富なスタンプ＆なりきり">
                </div>
            </div>
        </template>
    </layout-machine-introduction>
</template>

<script>
import LayoutMachineIntroduction from "../../templates/LayoutMachineIntroduction.vue";
import * as urlUtil from "../../../util/UrlUtil";
import {mapActions} from "vuex";

export default {
    name: "MachinePiemo1",
    components: {LayoutMachineIntroduction},
    props: {
        /**
         * Headerコンポーネント用
         * 未保存プリ数
         */
        unsavedPuriCount: {
            type: String,
            required: true
        },
        /**
         * Headerコンポーネント用
         * 最新プリID
         */
        latestImageId: {
            type: String,
            required: true
        },
        /**
         * 当該機種が「遊べるお店を探す」によって検索可能であるかどうかを判定する.
         * toolboxから取得
         * 「遊べるお店を探す」表示判定
         */
        isSearchable: {
            type: Boolean,
            required: true
        },
    },
    computed: {
        machineId() {
            return 153;
        },
        sectionTitleList() {
            return [
                '01 うるきら可愛い 純欲盛れ',
                '02 顔もスタイルも盛れる 新・全身撮影',
                '03 いつものプリがもっと可愛くなる 選べる背景',
                '04 トレンド可愛い 落書きコンテンツ',
            ];
        }
    },
    mounted() {
        /**
         * TheHeader,TheFooterでstoreのaccountStatusを使用するため、予めstoreに保存しておく
         * FIXME:ここでの取得を忘れてもエラーが出ず気づかない可能性があるため、VOYAGERFRONT-5558で修正予定
         */
        this.getAccountStatus()
    },
    methods: {
        ...mapActions({
            getAccountStatus: 'AccountStoreV2/getAccountStatus'
        }),
        /**
         * 画像のURLを組み立てる
         * @param {string} imgName 画像名
         */
        buildImgUrl(imgName) {
            return urlUtil.imageUrlUtil.machineIntroductionImageUrl(String(this.machineId), imgName)
        },
        /**
         * cssのurl関数の呼び出し部分の含めた文字列を返す
         * styleタグ内でv-bindで使用することを想定している
         */
        buildStyleImgUrl(imageName) {
            const imgUrl = this.buildImgUrl(imageName)
            return `url(${imgUrl})`;
        },
    }
}
</script>

<style scoped lang="scss">
@use "sass:math";
@use "../../../../scss/v2/base/variables";

$deviceWidth: 750px;

:deep(*) {
    .c-machine-introduction {
        &-top {
            .btn-puri-list {
                position: absolute;
                width: math.percentage(math.div(178px, $deviceWidth));
                top: math.percentage(math.div(208px, $deviceWidth));
                left: math.percentage(math.div(10px, $deviceWidth));
            }

            .btn-shop-list {
                position: absolute;
                top: math.percentage(math.div(380px, $deviceWidth));
                left: 0;
                width: 100%;

                &-link {
                    width: math.percentage(math.div(530px, $deviceWidth));
                }
            }

            .list-anchor-link {
                padding: (variables.$grid-base) 0 0 0;

                .img-link {
                    width: math.percentage(math.div(594px, $deviceWidth));
                }

                .img-line {
                    width: math.percentage(math.div(594px, $deviceWidth));
                    display: block;
                    margin: auto;
                }
            }

            .feature-summary {
                width: math.percentage(math.div(594px, $deviceWidth));
                padding: 0 0 (variables.$grid-base) 0;
                margin: auto;
            }
        }

        &-contents {
            .accordion-inner {
                .img-01, .img-02, .img-03, .img-04, .img-05, .img-06, .img-07, {
                    display: block;
                }

                .cont-02 {
                    .img-02-wrapper {
                        position: relative;

                        .gif-01 {
                            position: absolute;
                            top: 20%;
                            right: 53%;
                            width: math.percentage(math.div(240px, $deviceWidth));
                        }

                        .gif-02 {
                            position: absolute;
                            top: 20%;
                            right: 15%;
                            width: math.percentage(math.div(240px, $deviceWidth));
                        }
                    }

                    &-bk {
                        background: v-bind("buildStyleImgUrl('img_contents02_bk.png')");
                        background-size: cover;
                    }
                }

                .cont-03 {
                    &-bk {
                        background: v-bind("buildStyleImgUrl('img_contents03_bk.png')");
                        background-size: cover;
                    }
                }

                .cont-04 {
                    &-bk {
                        background: v-bind("buildStyleImgUrl('img_contents04_bk.png')");
                        background-size: cover;
                    }
                }
            }
        }

        &-movie {
            padding: variables.$grid-consistent * 24 0 variables.$grid-consistent * 14;
            background-image: v-bind("buildStyleImgUrl('movie_back.png')");
            background-repeat: no-repeat;
            background-position: center;
            background-size: cover;

            &-thumb {
                width: math.percentage(math.div(650px, $deviceWidth));
                margin: auto;
            }
        }
    }
}

</style>
